export const GET_RELEASE_NOTES = 'GET_RELEASE_NOTES'
export const GET_RELEASE_NOTES_SUCCESS = 'GET_RELEASE_NOTES_SUCCESS'
export const GET_RELEASE_NOTES_FAILED = 'GET_RELEASE_NOTES_FAILED'

export const GET_RELEASE_NOTE = 'GET_RELEASE_NOTE'
export const GET_RELEASE_NOTE_SUCCESS = 'GET_RELEASE_NOTE_SUCCESS'
export const GET_RELEASE_NOTE_FAILED = 'GET_RELEASE_NOTE_FAILED'

export const CREATE_RELEASE_NOTE = 'CREATE_RELEASE_NOTE'
export const CREATE_RELEASE_NOTE_SUCCESS = 'CREATE_RELEASE_NOTE_SUCCESS'
export const CREATE_RELEASE_NOTE_FAILED = 'CREATE_RELEASE_NOTE_FAILED'

export const UPDATE_RELEASE_NOTE = 'UPDATE_RELEASE_NOTE'
export const UPDATE_RELEASE_NOTE_SUCCESS = 'UPDATE_RELEASE_NOTE_SUCCESS'
export const UPDATE_RELEASE_NOTE_FAILED = 'UPDATE_RELEASE_NOTE_FAILED'

export const DELETE_RELEASE_NOTE = 'DELETE_RELEASE_NOTE'
export const DELETE_RELEASE_NOTE_SUCCESS = 'DELETE_RELEASE_NOTE_SUCCESS'
export const DELETE_RELEASE_NOTE_FAILED = 'DELETE_RELEASE_NOTE_FAILED'
